<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zoNdRb/tc-custom/9781497615519.jpg?1726519129358" alt="This image is the cover for the book Sentimental Journey, The Americana Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sentimental Journey, The Americana Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A Tennessee woman risks her heart on the secrets of a perfect new lover in this Americana romance from the <i>New York Times</i>–bestselling author.</b><br/>  <br/> Jessica Thorne, an advertising executive from Chattanooga, Tennessee, never expected such a blast from the past. Yet there he was: Brodie Hayes. Years ago, Brodie had pursued Jessica’s older sister, Jordanna, and got stung. A poor boy from the wrong side of the tracks, he couldn’t measure up to the Thorne family’s high standards. Now Brodie has returned to the city—handsome, charismatic, and wealthy beyond measure. And this time, he only has eyes for Jessica.<br/>  <br/> Jessica is flattered by Brodie’s lavish attention, charmed by his persistence, and astonished by his declaration of love. He’s definitely the kind of man Jessica has dreamed of, but she can’t help wondering: Is he living out the fantasies he still has for her sister? Or could it even be something as sinister as revenge? The answer is arriving soon. Jordanna is coming home to Chattanooga for a visit. Now, Jessica will find out if Brodie is the man of her dreams or too good to be true.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Dailey
      </h2>
      
      <p class="authorDescription body article">Janet Dailey, who passed away in 2013, was born Janet Haradon in 1944 in Storm Lake, Iowa. She attended secretarial school in Omaha, Nebraska, before meeting her husband, Bill. The two worked together in construction and land development until they &ldquo;retired&rdquo; to travel throughout the United States, inspiring Dailey to write the Americana series of romances, setting a novel in every state of the Union. In 1974, Dailey was the first American author to write for Harlequin. Her first novel was <I>No Quarter Asked</I>. She went&#160;on to write approximately ninety novels, twenty-one of which appeared on the <I>New York Times</I> bestseller list. She won many awards and accolades for her work, appearing widely on radio and television. Today, there are over three hundred million Janet Dailey books in print in nineteen different languages, making her one of the most popular novelists in the world. For more information about Dailey, visit www.janetdailey.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d6a5a5d